import { getRecentFiles } from "../GraphService";
import { recentFilesAdvancedSearchMapper } from "../../components/mappers/recentFilesAdvancedSearchMapper";
import { IAdvancedSearchRecentItem } from "../../interfaces/IAdvancedSearchRecentItem";

export class AdvancedSearchRecentItemBuilder {
    async getRecentItems(): Promise<IAdvancedSearchRecentItem[]> {
        const result = await getRecentFiles();
        const mapper = new recentFilesAdvancedSearchMapper();
        return mapper.map(result);
    }
}